import type { ProcessBtnType } from './SubscriptionRequestHistoryProcessModal';
import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export type FormRequest = {
  productPlanId: string;
  inquiry: string;
  requester?: string;
  files?: File[];
};

export type HistoryProcessFormRequest = {
  comment?: string;
  files?: File[];
  btnType: ProcessBtnType;
};

export type HistoryUpdateFormRequest = HistoryProcessFormRequest;
export const useItAdminForm = () => {
  const validationItAdminSchema = Yup.object().shape({
    productPlanId: Yup.string().required(),
    inquiry: Yup.string().nullable(),
    requester: Yup.string().nullable().optional(),
    files: Yup.array().of(Yup.mixed<File>()).optional(),
  });

  const ItAdminFormOptions: UseFormProps<FormRequest> = {
    resolver: yupResolver(validationItAdminSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<FormRequest>(ItAdminFormOptions);
};

export const useHistoryProcessForm = () => {
  const validationHistoryProcessSchema = Yup.object().shape({
    comment: Yup.string(),
    btnType: Yup.string().required('Product_Use_Request_10'),
    files: Yup.array().of(Yup.mixed<File>()).optional(),
  });
  const HistoryProcessFormOptions: UseFormProps<HistoryProcessFormRequest> = {
    resolver: yupResolver(validationHistoryProcessSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<HistoryProcessFormRequest>(HistoryProcessFormOptions);
};

export const useHistoryUpdateForm = () => {
  const validationUpdateHistoryProcessSchema = Yup.object().shape({
    comment: Yup.string(),
    files: Yup.array().of(Yup.mixed<File>()).optional(),
  });

  const HistoryUpdateFormOptions: UseFormProps<HistoryUpdateFormRequest> = {
    resolver: yupResolver(validationUpdateHistoryProcessSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<HistoryUpdateFormRequest>(HistoryUpdateFormOptions);
};
